export namespace VehicleFunctionsActions{
    export class SetAllVehicleFunctions {
        static readonly type = '[VehicleFunctions] SetAllVehicleFunctions';
        constructor() {}
    }
}
